import React, { useContext, useState } from 'react'
import { Popover } from '@headlessui/react'
import { Link, NavLink } from 'react-router-dom'
import AuthContext from '../../context/AuthContext'
import ArrowSmallRight from '../reusable/icons/ArrowSmallRight'
import { HiChevronRight, HiChevronDown } from 'react-icons/hi2'
import Dashboard from '../../assets/images/sidebar_icon1.svg'
import CompanyManager from '../../assets/images/company_manager.svg'
import JobsManager from '../../assets/images/employee-request.svg'
import Notification from '../../assets/images/notification_manager.svg'
import FormsManager from '../../assets/images/forms_manager.svg'
import Earning from '../../assets/images/earning_manager.svg'
import CountryManager from '../../assets/images/country_manager.svg'
import StateManager from '../../assets/images/country_manager.svg'
import CityManager from '../../assets/images/city_manager.svg'
import CategorySubcategory from '../../assets/images/category_subcategory_manager.svg'
import SubAdmin from '../../assets/images/subadmin_manager.svg'
import Subscription from '../../assets/images/subscription_manager.svg'
import StaticContent from '../../assets/images/static_contents.png'
import Support from '../../assets/images/support_manager.svg'
import Banner from '../../assets/images/banner_management.svg'
import Faq from '../../assets/images/faqs.svg'
import Reports from '../../assets/images/reports.png'
import Setting from '../../assets/images/setting_icon.svg'
import Logout from '../../assets/images/logout.svg'
import VideoManager from '../../assets/images/video_manager.svg'
import { useTranslation } from 'react-i18next'
import logoImage from '../../assets/images/logo_white.png'
import CustomNavLink from './CustomNavLink'
import helpers from 'utils/helpers'
import { FiActivity, FiBarChart2, FiClipboard, FiFileText, FiList, FiShield, FiDollarSign } from 'react-icons/fi'
import { FaMoneyCheckAlt } from 'react-icons/fa'
 
const classNames = require('classnames')
 
const Sidebar = () => {
  const { t } = useTranslation()
  const { logoutUser, user, sidebarStatus, updatePageName } = useContext(AuthContext)
 
  // State for the main accordion categories
  const [openMenus, setOpenMenus] = useState({})
  // State for the nested Reports popover
  const [reportPopup, setReportPopup] = useState(false)
 
  const toggleMenu = (menuKey) => {
    setOpenMenus(prev => ({
      ...prev,
      [menuKey]: !prev[menuKey]
    }))
  }
 
  const handleLogout = () => {
    if (window.confirm('Are you sure to logout?')) {
      logoutUser()
    }
  }
 
  const checkSidebarPermission = arg => {
    if (!user) {
      return false
    }
    const localPermissions = [...user?.permission]
 
    if (user?.permission?.length === 0) {
      return true
    }
    const perIndex = localPermissions?.findIndex(item => item?.manager === arg)
    if (perIndex < 0) {
      return false
    }
    if (localPermissions?.[perIndex]?.view) {
      return true
    }
 
    return false
  }
 
  // ---------------------------------------------------------
  // 1. CONFIGURATION ARRAY
  // ---------------------------------------------------------
  const menuConfig = [
    {
      key: 'system',
      label: 'System Management',
      icon: Setting,
      items: [
        { permission: 'subadmin_manager', path: '/sub-admin-manager', pageName: 'SUB_ADMIN_MANAGERS', icon: SubAdmin },
        { permission: 'company_manager', path: '/company-manager', pageName: 'COMPANY_MANAGER', icon: CompanyManager },
        { permission: 'forms-manager', path: '/forms-manager', pageName: 'FORMS_MANAGER', icon: FormsManager },
        { permission: 'category-subcategory-manager', path: '/category-subcategory-manager', pageName: 'CATEGORY_SUBCATEGORY_MANAGER', icon: CategorySubcategory },
        { permission: 'subscription_manager', path: '/subscription_manager', pageName: 'SUBSCRIPTION_MANAGER', icon: Subscription },
        // Use React Icon for Audit Logs
        { permission: 'audit_logs', path: '/audit-logs', pageName: 'AUDIT_LOGS', icon: FiActivity, isReactIcon: true },
        { permission: 'payroll-onboardings', path: '/payroll-onboardings', pageName: 'PAYROLL_ONBOARDING', icon: FaMoneyCheckAlt, isReactIcon: true },
        { permission: 'settings', path: '/settings', pageName: 'SETTINGS', icon: Setting }
      ]
    },
    {
      key: 'locations',
      label: 'Location Management',
      icon: CountryManager,
      items: [
        { permission: 'country_manager', path: '/country_manager', pageName: 'COUNTRY_MANAGER', icon: CountryManager },
        { permission: 'state_manager', path: '/state_manager', pageName: 'STATE_MANAGER', icon: StateManager },
        { permission: 'geo_access', path: '/geo-access', pageName: 'GEO_ACCESS', icon: FiShield, isReactIcon: true },
      ]
    },
    {
      key: 'financials',
      label: 'Financial & Earning',
      icon: Earning,
      items: [
        { permission: 'earning-managers', path: '/earning-managers', pageName: 'NAV_EARNING_MANAGER', icon: Earning },
        {
          permission: 'background_check_pricing',
          path: '/background-check-pricing',
          pageName: 'BACKGROUND_CHECK_PRICING',
          icon: FiDollarSign,
          isReactIcon: true
        }
      ]
    },
    {
      key: 'content',
      label: 'Content Management',
      icon: StaticContent,
      items: [
        { permission: 'jobs-manager', path: '/jobs-manager', pageName: 'JOBS_MANAGER', icon: JobsManager },
        { permission: 'static-page-management', path: '/static-page-management', pageName: 'NAV_STATIC_CONTENTS', icon: StaticContent, end: true },
        { permission: 'blog-management', path: '/blog-management', pageName: 'NAV_BLOG_MANAGEMENT', icon: StaticContent },
        { permission: 'video-management', path: '/video-management', pageName: 'NAV_VIDEO_MANAGEMENT', icon: VideoManager },
        // { permission: 'banner-management', path: '/banner-management', pageName: 'BANNER_MANAGER', icon: Banner },
        { permission: 'faqs', path: '/faqs', pageName: 'FAQS', icon: Faq },
      ]
    },
    {
      key: 'communications',
      label: 'Communications & Support',
      icon: Notification,
      items: [
        { permission: 'static-page-management', path: '/static-page-management/partner-inquiries', pageName: 'PARTNER_INQUIRIES', icon: Support },
        { permission: 'notification_manager', path: '/notification_manager', pageName: 'NOTIFICATION_MANAGER', icon: Notification },
        { permission: 'support_manager', path: '/support_manager', pageName: 'SUPPORT_MANAGER', icon: Support }
      ]
    }
  ]
 
  return (
    <>
      <div
        className={`sidebar lg:block z-10  ${helpers?.ternaryCondition(
          sidebarStatus === 'close',
          'hideSideBar',
          'block'
        )} bg-gradient-to-t from-gradpurple to-gradblue w-[220px] xl:w-[280px] fixed h-full overflow-y-auto`}
      >
        <div className='text-white'>
          <Link
            to='/dashboard'
            onClick={() => updatePageName('Dashboard')}
            className='px-2 py-6 w-full text-center flex justify-center'
          >
            <img src={logoImage} className='inline' alt='' />
          </Link>
          <div className='profile text-center pb-4'>
            <small className='block text-sm'>Welcome</small>
            <strong className='block text-lg overflow-hidden text-ellipsis px-2 whitespace-nowrap '>
              {user?.name}
            </strong>
          </div>
 
          <nav className='pt-4 pb-5 flex flex-col justify-center font-normal text-xs overflow-y-auto'>
           
            {/* STANDALONE DASHBOARD ITEM AT THE TOP */}
            <NavLink
              to='/dashboard'
              className={({ isActive }) =>
                classNames(
                  'flex items-center px-4 lg:px-7 py-4 text-white active:text-LightBlue hover:bg-white hover:text-LightBlue',
                  { active: isActive }
                )
              }
              onClick={() => updatePageName(t('NAV_DASHBOARD'))}
            >
              <span className='mr-2'>
                <img src={Dashboard} className='max-w-[18px]' alt='' />
              </span>
              {t('NAV_DASHBOARD')}
            </NavLink>
            <NavLink
              to='/business-intelligence'
              className={({ isActive }) =>
                classNames(
                  'flex items-center px-4 lg:px-7 py-4 text-white active:text-LightBlue hover:bg-white hover:text-LightBlue',
                  { active: isActive }
                )
              }
              onClick={() => updatePageName(t('NAV_BI_DASHBOARD'))}
            >
              <span className='mr-2'>
                <FiBarChart2 className='text-lg' />
              </span>
              {t('NAV_BI_DASHBOARD')}
            </NavLink>
 
            {/* --------------------------------------------------------- */}
            {/* 2. LOOP THROUGH ACCORDION CATEGORIES */}
            {/* --------------------------------------------------------- */}
            {menuConfig.map((category, i) => (
              <div key={category.key} className={`${i == 0 ? "border-t":""} border-b border-white/10 last:border-0`}>
               
                {/* Parent Category Header */}
                <button
                  onClick={() => toggleMenu(category.key)}
                  className="w-full text-left px-4 lg:px-7 py-4 text-white flex items-center justify-between hover:bg-white/10 transition-colors duration-200 focus:outline-none"
                >
                  <div className="flex items-center gap-3">
                    <span className='mr-1'>
                      <img className='max-w-[18px]' src={category.icon} alt='' />
                    </span>
                    <span className='font-medium tracking-wide uppercase text-xs'>{category.label}</span>
                  </div>
                 
                  {/* Small Chevron Arrow */}
                  <span className='text-xs'>
                    {openMenus[category.key] ? <HiChevronDown className='text-lg' /> : <HiChevronRight className='text-lg' />}
                  </span>
                </button>
 
                {/* Child Items (Accordion Body) */}
                {openMenus[category.key] && (
                  <div className="flex flex-col bg-black/10 pb-2">
                    {category.items.map((item, index) => {
                      // Render standard NavLink using the permission helper
                      if (checkSidebarPermission(item.permission)) {
                        return (
                          <CustomNavLink
                            key={index}
                            to={item.path}
                            end={item.end}
                            onClick={() => updatePageName(t(item.pageName))}
                            icon={item.icon}
                            isReactIcon={item.isReactIcon}
                            className="ml-6"
                          >
                            {t(item.pageName)}
                          </CustomNavLink>
                        )
                      }
                      return null;
                    })}
                  </div>
                )}
              </div>
            ))}
 
            {/* --------------------------------------------------------- */}
            {/* 3. SPECIAL CASE: REPORTS DROPDOWN (Fixed Alignment) */}
            {/* --------------------------------------------------------- */}
            {checkSidebarPermission('reports') && (
              <div className="border-b border-white/10">
                <Popover className='relative'>
                  {() => (
                    <>
                      <Popover.Button
                        onClick={() => setReportPopup(!reportPopup)}
                        style={{ width: '100%' }}
                        className='outline-none text-start flex items-center justify-between px-4 lg:px-7 py-4 text-white active:text-LightBlue hover:bg-white hover:text-LightBlue'
                      >
                        <div className="flex items-center">
                          <span className='mr-2'>
                            <img src={Reports} className='max-w-[18px]' alt='' />
                          </span>
                          {t('REPORTS')}
                        </div>
                       
                        {/* Fixed Alignment: Removed ml-2, wrapped in flex items-center */}
                        <span className='flex items-center'>
                          <HiChevronRight
                            className={helpers?.ternaryCondition(
                              reportPopup,
                              'text-lg w-5 h-5 rotate-90 transform transition-transform duration-200',
                              'text-lg w-5 h-5 transition-transform duration-200'
                            )}
                          />
                        </span>
                      </Popover.Button>
                      {reportPopup && (
                        <Popover.Panel className='' static={true}>
                          {[
                            {
                              to: '/report/registered_companies',
                              label: t('REGISTERED_COMPANIES')
                            },
                            {
                              to: '/report/subscription_statistics',
                              label: t('SUBSCRIPTION_STATISTICS')
                            }
                          ].map(({ to, label }) => (
                            <NavLink
                              key={to}
                              className={({ isActive }) =>
                                classNames(
                                  'flex items-center px-6 lg-px-12 py-2 text-white active:text-LightBlue hover:bg-white hover:text-LightBlue',
                                  {
                                    active: isActive
                                  }
                                )
                              }
                              to={to}
                              onClick={() => updatePageName(label)}
                            >
                              <ArrowSmallRight />
                              {label}
                            </NavLink>
                          ))}
                        </Popover.Panel>
                      )}
                    </>
                  )}
                </Popover>
              </div>
            )}
 
            {/* --------------------------------------------------------- */}
            {/* 4. LOGOUT AT THE BOTTOM */}
            {/* --------------------------------------------------------- */}
            <Link
              onClick={handleLogout}
              className='flex items-center px-4 lg:px-7 py-4 text-white active:text-LightBlue hover:bg-white hover:text-LightBlue'
            >
              <span className='mr-2'>
                <img src={Logout} className='max-w-[18px]' alt='logout' />
              </span>
              {t('NAV_LOGOUT')}
            </Link>
          </nav>
        </div>
      </div>
    </>
  )
}
 
export default Sidebar